import { Outlet } from 'react-router-dom';
import IndexNavBar from '../navbars/indexNavbar';
import { Container } from 'react-bootstrap';

function RootLayout() {
  return (
    <>
      <Container
        fluid
        className='root-container p-0 position-relative overflow-hidden h-100 w-100'
      >
      {/* <div className='gradient-bg-login' style={{right: '-200px', top: '-300px', width: '100%', height: '900px', transform: 'rotate(45deg)'}}></div> */}
        <IndexNavBar></IndexNavBar>
        <main className='main'>
          <Outlet />
        </main>
      </Container>
    </>
  );
}

export default RootLayout;
